import { useEffect } from "react";
import { useSubscription } from "../hooks/use-subscription";
import { Sentry } from "../sentry";

/** Sync Sentry user context from subscription (id + email). */
export function SentryUserSync() {
  const { subscription } = useSubscription();

  useEffect(() => {
    if (!process.env.REACT_APP_SENTRY_DSN) return;

    if (subscription?.email || subscription?.idUtente) {
      Sentry.setUser({
        id: subscription.idUtente ? String(subscription.idUtente) : undefined,
        email: subscription.email || undefined,
      });
      return;
    }

    Sentry.setUser(null);
  }, [subscription?.email, subscription?.idUtente]);

  return null;
}
